import type { Action } from 'redux';
import NotificationActions from '../../../../main/actions/NotificationActions';
import dash_api from '../../../../main/support/dash_api';
import { ReduxAsyncAction } from '../../../services/ReduxAsyncAction';
import type {
  UpdateConversionValueMappingRequestActionPayload,
  UpdateConversionValueMappingResponseActionPayload,
} from '../SKANPostbacksConversionMapping.types';

const UpdateConversionValueMapping = new ReduxAsyncAction<
  'UPDATE_CONVERSION_VALUE_MAPPING',
  UpdateConversionValueMappingRequestActionPayload,
  UpdateConversionValueMappingResponseActionPayload
>('UPDATE_CONVERSION_VALUE_MAPPING');

UpdateConversionValueMapping.registerRequest(
  async ({
    postbackIndexMapping,
    conversionValueMapping,
    skadnetworkRecommendationRevisionId,
    targetEvent,
    ascendingOnly,
    templateId,
  }: UpdateConversionValueMappingRequestActionPayload) => {
    try {
      const response = await dash_api.put<UpdateConversionValueMappingResponseActionPayload>(
        '/v1/skadnetworkv2/conversion-value-mapping',
        {
          postbackIndexMapping: postbackIndexMapping,
          conversionValueMapping: conversionValueMapping,
          ascendingOnly: ascendingOnly,
          targetEvent: targetEvent,
          skadnetworkRecommendationRevisionId: skadnetworkRecommendationRevisionId,
          templateId: templateId,
        }
      );

      return response.data;
    } catch (error) {
      NotificationActions.showNotification('Cannot update Conversion Value Mapping. Please try again.', 'error');

      throw error;
    }
  }
);

export const UPDATE_CONVERSION_VALUE_MAPPING = UpdateConversionValueMapping.actionNamespaceConstants;

export const updateConversionValueMapping = UpdateConversionValueMapping.request;

export type UpdateConversionValueMappingRequestAction = Action<typeof UPDATE_CONVERSION_VALUE_MAPPING.request>;

export type UpdateConversionValueMappingResponseAction = Action<typeof UPDATE_CONVERSION_VALUE_MAPPING.response> & {
  data: UpdateConversionValueMappingResponseActionPayload;
};
